/* eslint-disable */
export const PORTRAIT_COMPILED_CONFIG = {
  GRID: {
    FIT: {
      'with-border': {
        '1': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '34.648%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          }
        ],
        '2': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '18.88%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          }
        ],
        '3': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '3.111%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '34.648%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.184%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          }
        ],
        '4': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '34.466%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '34.466%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          }
        ],
        '5': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '26.49%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '26.49%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '42.441%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '42.441%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '58.391%',
              left: '26.111%',
              width: '47.777%',
              height: '15.117%'
            }
          }
        ],
        '6': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '26.49%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '26.49%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '42.441%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '42.441%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '58.391%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '58.391%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          }
        ],
        '7': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '18.515%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '18.515%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '34.466%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '34.466%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.367%',
              left: '26.111%',
              width: '47.777%',
              height: '15.117%'
            }
          }
        ],
        '8': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '18.515%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '18.515%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '34.466%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '34.466%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.367%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.367%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          }
        ]
      },
      'without-border': {
        '1': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '34.179%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          }
        ],
        '2': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '18.359%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          }
        ],
        '3': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '2.539%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '34.179%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '65.82%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          }
        ],
        '4': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '34.179%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '34.179%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          }
        ],
        '5': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '26.269%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '26.269%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '42.089%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '42.089%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '57.91%',
              left: '25%',
              width: '50%',
              height: '15.82%'
            }
          }
        ],
        '6': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '26.269%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '26.269%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '42.089%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '42.089%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '57.91%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '57.91%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          }
        ],
        '7': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '18.359%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '18.359%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '34.179%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '34.179%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '65.82%',
              left: '25%',
              width: '50%',
              height: '15.82%'
            }
          }
        ],
        '8': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '18.359%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '18.359%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '34.179%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '34.179%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '65.82%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '65.82%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          }
        ]
      }
    },
    FILL: {
      'with-border': {
        '1': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '0.833%',
              left: '1.481%',
              width: '97.037%',
              height: '98.333%'
            }
          }
        ],
        '2': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '0.833%',
              left: '1.481%',
              width: '97.037%',
              height: '48.75%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '97.037%',
              height: '48.75%'
            }
          }
        ],
        '3': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '0.833%',
              left: '1.481%',
              width: '97.037%',
              height: '32.222%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '33.888%',
              left: '1.481%',
              width: '97.037%',
              height: '32.222%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.944%',
              left: '1.481%',
              width: '97.037%',
              height: '32.222%'
            }
          }
        ],
        '4': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '0.833%',
              left: '1.481%',
              width: '47.777%',
              height: '48.75%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '0.833%',
              left: '50.74%',
              width: '47.777%',
              height: '48.75%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '47.777%',
              height: '48.75%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '50.74%',
              width: '47.777%',
              height: '48.75%'
            }
          }
        ],
        '5': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '0.833%',
              left: '1.481%',
              width: '47.777%',
              height: '32.222%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '0.833%',
              left: '50.74%',
              width: '47.777%',
              height: '32.222%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '33.888%',
              left: '1.481%',
              width: '47.777%',
              height: '32.222%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '33.888%',
              left: '50.74%',
              width: '47.777%',
              height: '32.222%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.944%',
              left: '26.111%',
              width: '47.777%',
              height: '32.222%'
            }
          }
        ],
        '6': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '0.833%',
              left: '1.481%',
              width: '47.777%',
              height: '32.222%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '0.833%',
              left: '50.74%',
              width: '47.777%',
              height: '32.222%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '33.888%',
              left: '1.481%',
              width: '47.777%',
              height: '32.222%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '33.888%',
              left: '50.74%',
              width: '47.777%',
              height: '32.222%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.944%',
              left: '1.481%',
              width: '47.777%',
              height: '32.222%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.944%',
              left: '50.74%',
              width: '47.777%',
              height: '32.222%'
            }
          }
        ],
        '7': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '0.833%',
              left: '1.481%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '0.833%',
              left: '50.74%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '25.624%',
              left: '1.481%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '25.624%',
              left: '50.74%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '50.74%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '75.208%',
              left: '26.111%',
              width: '47.777%',
              height: '23.958%'
            }
          }
        ],
        '8': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '0.833%',
              left: '1.481%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '0.833%',
              left: '50.74%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '25.624%',
              left: '1.481%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '25.624%',
              left: '50.74%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '50.74%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '75.208%',
              left: '1.481%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '75.208%',
              left: '50.74%',
              width: '47.777%',
              height: '23.958%'
            }
          }
        ]
      },
      'without-border': {
        '1': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '0%',
              left: '0%',
              width: '100%',
              height: '100%'
            }
          }
        ],
        '2': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '0%',
              left: '0%',
              width: '100%',
              height: '50%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '100%',
              height: '50%'
            }
          }
        ],
        '3': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '0%',
              left: '0%',
              width: '100%',
              height: '33.333%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '33.333%',
              left: '0%',
              width: '100%',
              height: '33.333%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '66.666%',
              left: '0%',
              width: '100%',
              height: '33.333%'
            }
          }
        ],
        '4': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '0%',
              left: '0%',
              width: '50%',
              height: '50%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '0%',
              left: '50%',
              width: '50%',
              height: '50%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '50%',
              height: '50%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '50%'
            }
          }
        ],
        '5': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '0%',
              left: '0%',
              width: '50%',
              height: '33.333%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '0%',
              left: '50%',
              width: '50%',
              height: '33.333%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '33.333%',
              left: '0%',
              width: '50%',
              height: '33.333%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '33.333%',
              left: '50%',
              width: '50%',
              height: '33.333%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '66.666%',
              left: '25%',
              width: '50%',
              height: '33.333%'
            }
          }
        ],
        '6': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '0%',
              left: '0%',
              width: '50%',
              height: '33.333%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '0%',
              left: '50%',
              width: '50%',
              height: '33.333%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '33.333%',
              left: '0%',
              width: '50%',
              height: '33.333%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '33.333%',
              left: '50%',
              width: '50%',
              height: '33.333%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '66.666%',
              left: '0%',
              width: '50%',
              height: '33.333%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '66.666%',
              left: '50%',
              width: '50%',
              height: '33.333%'
            }
          }
        ],
        '7': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '0%',
              left: '0%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '0%',
              left: '50%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '25%',
              left: '0%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '25%',
              left: '50%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '75%',
              left: '25%',
              width: '50%',
              height: '25%'
            }
          }
        ],
        '8': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '0%',
              left: '0%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '0%',
              left: '50%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '25%',
              left: '0%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '25%',
              left: '50%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '75%',
              left: '0%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '75%',
              left: '50%',
              width: '50%',
              height: '25%'
            }
          }
        ]
      }
    }
  },
  FOCUS: {
    FIT: {
      'with-border': {
        '2': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '18.88%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          }
        ],
        '3': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '3.111%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '34.648%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.184%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          }
        ],
        '4': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '18.697%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.234%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.234%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.184%',
              left: '26.111%',
              width: '47.777%',
              height: '15.117%'
            }
          }
        ],
        '5': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '18.697%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.234%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.234%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.184%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.184%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          }
        ],
        '6': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '10.722%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '42.259%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '42.259%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '58.209%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '58.209%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '74.16%',
              left: '26.111%',
              width: '47.777%',
              height: '15.117%'
            }
          }
        ],
        '7': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '10.722%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '42.259%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '42.259%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '58.209%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '58.209%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '74.16%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '74.16%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          }
        ],
        '8': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '2.747%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '34.283%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '34.283%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.234%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.234%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.184%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.184%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '82.135%',
              left: '26.111%',
              width: '47.777%',
              height: '15.117%'
            }
          }
        ],
        '9': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '2.747%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '34.283%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '34.283%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.234%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.234%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.184%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.184%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '82.135%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '82.135%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          }
        ]
      },
      'without-border': {
        '2': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '18.359%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          }
        ],
        '3': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '2.539%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '34.179%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '65.82%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          }
        ],
        '4': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '18.359%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '65.82%',
              left: '25%',
              width: '50%',
              height: '15.82%'
            }
          }
        ],
        '5': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '18.359%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '65.82%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '65.82%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          }
        ],
        '6': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '10.449%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '42.089%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '42.089%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '57.91%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '57.91%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '73.73%',
              left: '25%',
              width: '50%',
              height: '15.82%'
            }
          }
        ],
        '7': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '10.449%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '42.089%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '42.089%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '57.91%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '57.91%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '73.73%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '73.73%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          }
        ],
        '8': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '2.539%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '34.179%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '34.179%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '65.82%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '65.82%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '81.64%',
              left: '25%',
              width: '50%',
              height: '15.82%'
            }
          }
        ],
        '9': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '2.539%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '34.179%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '34.179%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '65.82%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '65.82%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '81.64%',
              left: '0%',
              width: '50%',
              height: '15.82%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '81.64%',
              left: '50%',
              width: '50%',
              height: '15.82%'
            }
          }
        ]
      }
    },
    FILL: {
      'with-border': {
        '2': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '0.833%',
              left: '1.481%',
              width: '97.037%',
              height: '48.75%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '97.037%',
              height: '48.75%'
            }
          }
        ],
        '3': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '0.833%',
              left: '1.481%',
              width: '97.037%',
              height: '48.75%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '47.777%',
              height: '48.75%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '50.74%',
              width: '47.777%',
              height: '48.75%'
            }
          }
        ],
        '4': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '0.833%',
              left: '1.481%',
              width: '97.037%',
              height: '48.75%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '50.74%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '75.208%',
              left: '26.111%',
              width: '47.777%',
              height: '23.958%'
            }
          }
        ],
        '5': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '0.833%',
              left: '1.481%',
              width: '97.037%',
              height: '48.75%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '50.74%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '75.208%',
              left: '1.481%',
              width: '47.777%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '75.208%',
              left: '50.74%',
              width: '47.777%',
              height: '23.958%'
            }
          }
        ],
        '6': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '0.833%',
              left: '1.481%',
              width: '97.037%',
              height: '48.75%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '47.777%',
              height: '15.694%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '50.74%',
              width: '47.777%',
              height: '15.694%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.944%',
              left: '1.481%',
              width: '47.777%',
              height: '15.694%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '66.944%',
              left: '50.74%',
              width: '47.777%',
              height: '15.694%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '83.472%',
              left: '26.111%',
              width: '47.777%',
              height: '15.694%'
            }
          }
        ],
        '7': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '0.833%',
              left: '1.481%',
              width: '97.037%',
              height: '48.75%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '31.357%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '34.32%',
              width: '31.357%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '67.16%',
              width: '31.357%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '75.208%',
              left: '1.481%',
              width: '31.357%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '75.208%',
              left: '34.32%',
              width: '31.357%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '75.208%',
              left: '67.16%',
              width: '31.357%',
              height: '23.958%'
            }
          }
        ],
        '8': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '0.833%',
              left: '1.481%',
              width: '97.037%',
              height: '34.531%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '36.197%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '36.197%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '52.148%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '52.148%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '68.098%',
              left: '1.481%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '68.098%',
              left: '50.74%',
              width: '47.777%',
              height: '15.117%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '84.049%',
              left: '26.111%',
              width: '47.777%',
              height: '15.117%'
            }
          }
        ],
        '9': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '8px',
              top: '0.833%',
              left: '1.481%',
              width: '97.037%',
              height: '48.75%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '1.481%',
              width: '23.148%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '26.111%',
              width: '23.148%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '50.74%',
              width: '23.148%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '50.416%',
              left: '75.37%',
              width: '23.148%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '75.208%',
              left: '1.481%',
              width: '23.148%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '75.208%',
              left: '26.111%',
              width: '23.148%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '75.208%',
              left: '50.74%',
              width: '23.148%',
              height: '23.958%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '75.208%',
              left: '75.37%',
              width: '23.148%',
              height: '23.958%'
            }
          }
        ]
      },
      'without-border': {
        '2': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '0%',
              left: '0%',
              width: '100%',
              height: '50%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '100%',
              height: '50%'
            }
          }
        ],
        '3': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '0%',
              left: '0%',
              width: '100%',
              height: '50%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '50%',
              height: '50%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '50%'
            }
          }
        ],
        '4': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '0%',
              left: '0%',
              width: '100%',
              height: '50%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '75%',
              left: '25%',
              width: '50%',
              height: '25%'
            }
          }
        ],
        '5': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '0%',
              left: '0%',
              width: '100%',
              height: '50%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '75%',
              left: '0%',
              width: '50%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '75%',
              left: '50%',
              width: '50%',
              height: '25%'
            }
          }
        ],
        '6': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '0%',
              left: '0%',
              width: '100%',
              height: '50%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '50%',
              height: '16.666%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '50%',
              height: '16.666%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '66.666%',
              left: '0%',
              width: '50%',
              height: '16.666%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '66.666%',
              left: '50%',
              width: '50%',
              height: '16.666%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '83.333%',
              left: '25%',
              width: '50%',
              height: '16.666%'
            }
          }
        ],
        '7': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '0%',
              left: '0%',
              width: '100%',
              height: '50%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '33.333%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '33.333%',
              width: '33.333%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '66.666%',
              width: '33.333%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '75%',
              left: '0%',
              width: '33.333%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '75%',
              left: '33.333%',
              width: '33.333%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '75%',
              left: '66.666%',
              width: '33.333%',
              height: '25%'
            }
          }
        ],
        '8': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '0%',
              left: '0%',
              width: '100%',
              height: '43.75%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '43.75%',
              left: '0%',
              width: '50%',
              height: '14.062%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '43.75%',
              left: '50%',
              width: '50%',
              height: '14.062%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '57.812%',
              left: '0%',
              width: '50%',
              height: '14.062%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '57.812%',
              left: '50%',
              width: '50%',
              height: '14.062%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '71.875%',
              left: '0%',
              width: '50%',
              height: '14.062%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '71.875%',
              left: '50%',
              width: '50%',
              height: '14.062%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '85.937%',
              left: '25%',
              width: '50%',
              height: '14.062%'
            }
          }
        ],
        '9': [
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              position: 'absolute',
              overflow: 'hidden',
              borderRadius: '0px',
              top: '0%',
              left: '0%',
              width: '100%',
              height: '50%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '0%',
              width: '25%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '25%',
              width: '25%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: '25%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '50%',
              left: '75%',
              width: '25%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '75%',
              left: '0%',
              width: '25%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '75%',
              left: '25%',
              width: '25%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '75%',
              left: '50%',
              width: '25%',
              height: '25%'
            }
          },
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '0px',
              position: 'absolute',
              top: '75%',
              left: '75%',
              width: '25%',
              height: '25%'
            }
          }
        ]
      }
    }
  },
  PIP: {
    FIT: {
      'with-border': {
        '2': [
          // Main speaker (full screen background)
          {
            style: {
              objectFit: 'cover',
              width: '100%',
              height: '100%'
            },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '14.648%',
              left: '1.481%',
              width: '97.037%',
              height: '30.703%'
            }
          },
          {
            style: { objectFit: 'cover', width: '100%', height: '100%' },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '44%',
              left: '26.3%',
              width: '47.40%',
              height: '15%',
              zIndex: 10
            }
          }
        ]
      },
      'without-border': {
        '2': [
          {
            style: { objectFit: 'cover', width: '100%', height: '100%' },
            containerStyle: {
              overflow: 'hidden',
              position: 'absolute',
              top: '14.18%',
              left: '0%',
              width: '100%',
              height: '31.64%'
            }
          },
          {
            style: { objectFit: 'cover', width: '100%', height: '100%' },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '44%',
              left: '26.3%',
              width: '47.40%',
              height: '15%',
              zIndex: 10
            }
          }
        ]
      }
    },
    FILL: {
      'with-border': {
        '2': [
          {
            style: { objectFit: 'cover', width: '100%', height: '100%' },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '8px',
              position: 'absolute',
              top: '0.833%',
              left: '0.833%',
              width: '98.333%',
              height: '98.333%'
            }
          },
          {
            style: { objectFit: 'cover', width: '100%', height: '100%' },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '100%',
              position: 'absolute',
              top: '85%',
              left: '74%',
              width: '22.5%',
              height: '12.65625%',
              zIndex: 10
            }
          }
        ]
      },
      'without-border': {
        '2': [
          {
            style: { objectFit: 'cover', width: '100%', height: '100%' },
            containerStyle: {
              overflow: 'hidden',
              position: 'absolute',
              top: '0%',
              left: '0%',
              width: '100%',
              height: '100%'
            }
          },
          {
            style: { objectFit: 'cover', width: '100%', height: '100%' },
            containerStyle: {
              overflow: 'hidden',
              borderRadius: '100%',
              position: 'absolute',
              top: '85%',
              left: '74%',
              width: '22.5%',
              height: '12.65625%',
              zIndex: 10
            }
          }
        ]
      }
    }
  }
};
